export default "__VITE_ASSET__CdoUpoXS__"